"use client";

import Button from 'src/components/button/Button';
import { getMovieChartText } from 'src/components/kinotoppen/kinotoppenHelpers';
import { ChartType } from 'src/lib/client/useMovieChart';
import styled from 'src/lib/styles/css';
import { useState } from 'react';

//#region [Props]
type MovieChartSelectorProps = {
	chartType: ChartType;
	setChartType: (chartType: ChartType) => void;
};
//#endregion

//#region [Component]
export default function MovieChartSelector({ chartType, setChartType }: MovieChartSelectorProps) {
	const [showPeriodOptions, setShowPeriodOptions] = useState(false);

	const typeHandler = (ct: ChartType) => {
		setShowPeriodOptions(false);
		setChartType(ct);
	};

	return <SMovieChartSelector>
		<SButton text={getMovieChartText(chartType)}
			onClick={() => setShowPeriodOptions(!showPeriodOptions)}
			role="combobox"
			aria-labelledby="select button"
			aria-haspopup="listbox"
			aria-expanded={showPeriodOptions}
			aria-controls="select-dropdown"
		/>

		{showPeriodOptions && <SOptionsContainer>
			<SLabel htmlFor='select-dropdown'>Velg tidsrom</SLabel>
			<SMovieChartOptions role='listbox' id="select-dropdown">
				<SOption role='option' aria-selected={chartType === "weekend"} onClick={() => typeHandler("weekend")} >Helg</SOption>
				<SOption role='option' aria-selected={chartType === "week"} onClick={() => typeHandler("week")}>Uke</SOption>
				<SOption role='option' aria-selected={chartType === "year"} onClick={() => typeHandler("year")}>År</SOption>
				<SOption role='option' aria-selected={chartType === "opening"} onClick={() => typeHandler("opening")}>Åpningshelger</SOption>
			</SMovieChartOptions>
		</SOptionsContainer>}
	</SMovieChartSelector>;
}
//#endregion

//#region [Styles]
const SMovieChartSelector = styled.div`
	position: relative;
	display: inline-flex;
	flex-direction: column;
`;

const SButton = styled(Button)`
	text-transform: capitalize;
`;

const SOptionsContainer = styled.div`
	position: absolute;
	z-index: 10;
	top: 34px;
	left: 0;
	color: var(--textcolor);
	border-radius: 8px;
	background-color: var(--buttoncolor);
	padding: 20px;
`;

const SMovieChartOptions = styled.ul`
	list-style: none;
	margin: 0;
	padding: 0;
`;

const SLabel = styled.label`
	font-size: 1.5rem;
	margin-bottom: 10px;
	white-space: nowrap;
`;

const SOption = styled.li`
	&:hover {
		text-decoration: underline;
		cursor: pointer;
	}
`;
//#endregion